import { isServer } from 'src/utils/environment';
import { LocationDetectionResult, MarketConfig } from './types';

export const detectUserLocation = (): LocationDetectionResult | undefined => {
  // Read country code from meta tag injected by Netlify Edge Function
  const metaCode = !isServer() ? document.querySelector('meta[name=country-code]') : null;
  const metaName = !isServer() ? document.querySelector('meta[name=country-name]') : null;

  const countryCode = metaCode?.getAttribute('content') || 'US';
  const countryName = metaName?.getAttribute('content') || 'United States';

  const isUS = countryCode === 'US';

  const marketConfig: MarketConfig = {
    countryCode,
    countryName,
  };

  return {
    countryCode,
    isUS,
    marketConfig,
  };
};
